import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmCustomerAccessRoute: InvariantJiraRoute = {
	name: 'products-jsm-customer-access',
	path: '/jira/settings/products/servicedesk/customer-access',
	exact: true,
};
